import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  monitorRunner,
  runner
} from '../../docs-routes'
import { useModule } from '@eggplant/routing'

const LinkToRunnerDoc = () => {
  const [isMonitorFlag] = useModule()

  const docsPath = !isMonitorFlag
    ? runner
    : monitorRunner

  const runnerTypeTitle = !isMonitorFlag
    ? 'Runner'
    : 'Monitor Runner'

  return (
    <LinkToDocusaurus path={docsPath}>
      Learn more about {runnerTypeTitle}
    </LinkToDocusaurus>
  )
}

export default LinkToRunnerDoc
